import React, { useState, useEffect } from 'react'
import { Table, Typography, Empty } from 'antd'
import { backend } from '../../api'

const { Text } = Typography

export default function OperationLog() {
  const [loading, setLoading] = useState(false)
  const [logs, setLogs] = useState([])

  useEffect(() => {
    loadLogs()
  }, [])

  const loadLogs = async () => {
    setLoading(true)
    try {
      const res = await backend.getOperationLogs()
      const data = res?.data || res || {}
      const list = Array.isArray(data) ? data : (data.logs || data.records || [])
      setLogs(list.slice(0, 500))
    } catch (e) {
      setLogs([])
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: '时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      render: val => {
        if (!val) return '-'
        return new Date(val).toLocaleString('zh-CN')
      }
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: val => {
        if (!val) return '-'
        return <Text code>{val}</Text>
      }
    },
    {
      title: '详情',
      dataIndex: 'detail',
      key: 'detail',
      render: val => {
        if (!val) return '-'
        return <Text type="secondary">{val}</Text>
      }
    }
  ]

  return (
    <div>
      <Table
        dataSource={logs}
        columns={columns}
        rowKey={(record, index) => record.id || record.created_at || index}
        loading={loading}
        pagination={{ pageSize: 20, showSizeChanger: true, showTotal: total => `共 ${total} 条` }}
        size="small"
        locale={{ emptyText: <Empty description="暂无操作日志" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
      />
    </div>
  )
}
